import { Dispatch, FC, JSX, ReactNode, SetStateAction, useRef, useState } from 'react';
import classNames from 'classnames';
import { Popover } from '../components/Popover/Popover';

export type InjectedProps = { setShowDropDown: Dispatch<SetStateAction<boolean>> };

type Props = {
    readonly label?: string;
    readonly className?: string;
    readonly children: ReactNode | ((props: InjectedProps) => JSX.Element);
};

export const CopiesListDropdown: FC<Props> = ({ label, className, children }) => {
    const [showDropDown, setShowDropDown] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    return (
        <div
            ref={dropdownRef}
            className={classNames(
                'default-dd-nav',
                'expanded-dd',
                'detailed-info',
                'muc',
                className,
                showDropDown && 'active'
            )}
        >
            <a onClick={() => setShowDropDown(it => !it)} className="bt-dd">
                <i className="material-icons up">info_outline</i>
                {label && <span className="fl-left txt-small cold-grey">{label}</span>}
                <i className="material-icons closed">expand_more</i>
                <i className="material-icons opened">expand_less</i>
            </a>
            <Popover target={dropdownRef} visible={showDropDown} placement="bottom" onClose={setShowDropDown}>
                <div className="default-dd">
                    {typeof children === 'function' ? children({ setShowDropDown }) : children}
                </div>
            </Popover>
        </div>
    );
};
